import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty, eq, toUpper } from 'lodash';

import { getAlphabetAnd123 } from '../../../utils/';
import { buildPathPrefix } from '../../../utils/directoryUtils';

import LocalizedNavLink from '../../router/LocalizedNavLink';

class ABCBookComponent extends React.Component {
    buildPathPrefix = () =>
        buildPathPrefix(
            this.props.locale,
            this.props.isCodePromo,
            this.props.isOffline,
            this.props.isEbon,
            this.props.isAllOffers
        );

    // RGAA 6.1 : le title reprend l'intitulé du lien (la lettre) en le
    // contextualisant.
    getLetterLinkTitle = l => {
        const { i18n } = this.props;
        return l === '123'
            ? i18n.LETTER_LINK_TITLE_123
            : i18n.LETTER_LINK_TITLE.replace('{0}', toUpper(l));
    };

    render() {
        const { letter, search, i18n } = this.props;

        return (
            !isEmpty(letter) && (
                <section>
                    <hr className="annuaire-menu-alphabet-hr" />
                    <nav
                        id="annuaire-menu-alphabet"
                        className="flex-container-h"
                        aria-label={i18n.NAV_LABEL}>
                        {getAlphabetAnd123().map(l => {
                            return eq(l, letter) ? (
                                <b key={l}>{toUpper(l)}</b>
                            ) : (
                                <LocalizedNavLink
                                    key={l}
                                    title={this.getLetterLinkTitle(l)}
                                    // La query string (?sort=...) est propagée pour
                                    // conserver le tri choisi en changeant de lettre.
                                    to={`${this.buildPathPrefix()}/alphabetique/${l}${search ||
                                        ''}`}>
                                    {toUpper(l)}
                                </LocalizedNavLink>
                            );
                        })}
                    </nav>
                    <hr className="annuaire-menu-alphabet-hr" />
                </section>
            )
        );
    }
}

ABCBookComponent.propTypes = {
    isCodePromo: PropTypes.bool.isRequired,
    letter: PropTypes.string,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool,
    isAllOffers: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        locale: state.i18n.locale,
        search: state.routing.location.search,
        i18n: state.i18n.page.DIRECTORY.A_Z
    };
};
export default connect(mapStateToProps)(ABCBookComponent);



// WEBPACK FOOTER //
// ./src/components/pages/directory/ABCBookComponent.js